import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppConfig } from '@ltvco/refresh-lib/ctx';
import FrontScratchesIllustration from 'images/damage-analyzer/front-scratches.svg';
import { ReportSectionCTACard } from 'components/shared/ReportSectionCTACard';

export const DamageAnalyzerCTA = () => {
  const navigate = useNavigate();
  const { trackEventGA4 } = useContext(AppConfig);

  const handleAnalyzeDamageClick = useCallback(() => {
    trackEventGA4({
      event_name: 'cta_click',
      type: 'view damage analyzer',
    });
    navigate('/bumper-chat/chat/photo-damage-analyzer');
  }, [navigate, trackEventGA4]);

  return (
    <ReportSectionCTACard
      id="damage-analyzer-cta"
      headline="Analyze Vehicle Damage with AI"
      bodyText="Upload photos of damage to get an estimated repair cost, severity, and whether fixing it makes sense for this vehicle."
      buttonText="Analyze Damage"
      onButtonClick={handleAnalyzeDamageClick}
      illustration={{
        src: FrontScratchesIllustration,
        alt: 'Damage analyzer preview showing a sample analysis result',
      }}
      dataTestId="damage-analyzer-cta"
    />
  );
};
